// Copied from the J7 spike (spikes/media-export), validated there.
import { encode as jsquashEncode } from '@jsquash/webp';
import type { Variant } from '../editor/lod';
import { planResize } from './resize';

export const QUALITY: Record<Variant, number> = { 2560: 0.82, 1024: 0.78, 256: 0.7 };

let nativeWebp: boolean | undefined;
/** Native WebP encoding via OffscreenCanvas (Chrome/Firefox yes; Safari is expected to say no [U]). */
export async function canEncodeWebp(): Promise<boolean> {
  if (nativeWebp !== undefined) return nativeWebp;
  try {
    const blob = await new OffscreenCanvas(1, 1).convertToBlob({ type: 'image/webp' });
    nativeWebp = blob.type === 'image/webp';
  } catch {
    nativeWebp = false;
  }
  return nativeWebp;
}

export async function encodeVariant(bitmap: ImageBitmap, edge: Variant, quality = QUALITY[edge]): Promise<{ blob: Blob; encoder: 'native' | 'jsquash'; w: number; h: number }> {
  const plan = planResize(bitmap.width, bitmap.height, edge);
  let source: ImageBitmap | OffscreenCanvas = bitmap;
  for (const step of plan.steps) {
    const canvas = new OffscreenCanvas(step.w, step.h);
    const ctx = canvas.getContext('2d')!;
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(source, 0, 0, step.w, step.h);
    source = canvas;
  }
  const canvas = source instanceof OffscreenCanvas ? source : new OffscreenCanvas(plan.w, plan.h);
  if (!(source instanceof OffscreenCanvas)) canvas.getContext('2d')!.drawImage(source, 0, 0);
  if (await canEncodeWebp()) {
    return { blob: await canvas.convertToBlob({ type: 'image/webp', quality }), encoder: 'native', w: plan.w, h: plan.h };
  }
  const data = canvas.getContext('2d')!.getImageData(0, 0, plan.w, plan.h);
  const buf = await jsquashEncode(data, { quality: Math.round(quality * 100) });
  return { blob: new Blob([buf], { type: 'image/webp' }), encoder: 'jsquash', w: plan.w, h: plan.h };
}
